<mat-form-field fxFlexFill appearance="outline">
    <mat-label>{{ placeholder }}</mat-label>
    <input type="text" placeholder="{{placeholder}}" [required]="required" aria-label="Company" matInput [formControl]="searchTerm" [matAutocomplete]="auto">
    <span *ngIf="selectedCompany" matSuffix>
        <syn-source class="syn-source__small" [source]="selectedCompany.source"></syn-source>
    </span>
</mat-form-field>
<mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
    <mat-option [value]="" (onSelectionChange)="onSelectionChange($event)">Aucune</mat-option>   
    <mat-option *ngFor="let company of filteredCompanies | async" [value]="company" (onSelectionChange)="onSelectionChange($event, company)">
        {{ company.name }}
        <syn-source class="syn-source__small" [source]="company.source"></syn-source>
    </mat-option>
</mat-autocomplete>
